import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ReportCredit from '@/pages/report-credit/ReportCredit'

export default {
  path: '/report-credit',
  name: 'CreditReport',
  components: {
    mainContent: ReportCredit,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'report-credit'
    },
    breadcrumb: {
      title: 'Relatórios de Créditos',
      paths: [
        { title: 'Relatórios' },
        { title: 'Relatórios de Créditos' }
      ]
    }
  }
}